import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ColumnDataType } from '../../core/utils/enums';
import {isEmpty} from "../../core/utils/functions";

export enum DateFormat {
  Date = 'dd/MM/yyyy',
  DateHour = 'HH:mm dd/MM/yyyy',
  DateTime = 'HH:mm:ss dd/MM/yyyy',
}

export enum MapKeyType {
  String,
  Number,
  Boolean,
}

@Pipe({
  name: 'map',
  standalone: true,
})
export class MapPipe implements PipeTransform {
  private datePipe: DatePipe = new DatePipe('en-US');
  private decimalPipe: DecimalPipe = new DecimalPipe('en-US');

  constructor(private translate: TranslateService) {}

  transform(value: any, arg?: any): any {
    if (!arg || isEmpty(value) || value === '---') {
      return '---';
    }
    let type: string = arg;
    let param = '';
    if (arg.indexOf(':') !== -1) {
      type = arg.substring(0, arg.indexOf(':'));
      param = arg.substring(arg.indexOf(':') + 1, arg.length);
    } else {
      param = DateFormat.Date;
    }

    switch (type) {
      case ColumnDataType.Date:
        return this.datePipe.transform(value, param) ?? '---';
      case ColumnDataType.DateTime:
        return this.datePipe.transform(value, DateFormat.DateTime) ?? '---';
      case ColumnDataType.DateHour:
        return this.datePipe.transform(value, DateFormat.DateHour) ?? '---';
      case ColumnDataType.Currency:
        const currency = this.decimalPipe.transform(value, '1.0-2');
        return currency ? currency + ' VND' : '---';
      case ColumnDataType.Number:
        const number = this.decimalPipe.transform(value, '1.0-2');
        return number ? number : '---';
      case ColumnDataType.Array:
        const array = value.join(', ');
        return array ? array : '---';
      case ColumnDataType.Boolean:
        return this.translate.instant(!!value ? 'button.yes' : 'button.no');
      default:
        return this.translate.instant(value?.toString() ?? '');
    }
  }
}
